export const navigation = [
    {
        name: '相談入力',
        url: '/input',
        icon: 'icon-note'
    },
    {
        name: '相談一覧',
        url: '/list',
        icon: 'icon-list'
    },
    {
        name: 'システム設定',
        url: '/setting',
        icon: 'icon-settings',
        children: [
            {
              name: '　　マスタメンテ',
              url: '/setting/classification',
            },
            {
                name: '　　お知らせ管理',
                url: '/setting/notification',
            },
            {
              name: '　　ユーザ管理',
              url: '/setting/user',
            }
          ]
    },
];



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/_nav.ts